import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { RouterPaths } from './_others/_helpers/router-paths';
import { PwaService } from './_services/_core/pwa.service';
import { GuideOverlayComponent } from './guide/guide-overlay/guide-overlay.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, GuideOverlayComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {
  private _pwaService = inject(PwaService);
  private _breakpointObserver = inject(BreakpointObserver);
  private _router = inject(Router);

  constructor() {
    this._setupDesktopRedirect();
    this._pwaService.initPwaUpdates();
  }

  private _setupDesktopRedirect(): void {
    this._breakpointObserver
      .observe([Breakpoints.Handset])
      .pipe(takeUntilDestroyed())
      .subscribe(() => this._checkAndRedirect());
  }

  private _checkAndRedirect(): void {
    const isMobile = this._breakpointObserver.isMatched([Breakpoints.Handset]);

    const isAllowedPageForDesktop = [
      `/${RouterPaths.LANDING}`,
      `/${RouterPaths.PRIVACY_POLICY}`,
    ].includes(this._router.url);

    if (!isMobile && !isAllowedPageForDesktop) {
      this._router.navigate([RouterPaths.LANDING]);
    }
  }
}
